<template>
  <b-container fluid>
    <b-modal v-model="infoModal"
             size="lg"
             header-bg-variant="primary"
             header-text-variant="light"
             :no-close-on-esc="true"
             :no-close-on-backdrop="true"
             :hide-header-close="true"
             v-bind:title="bookDto.title">
      <b-card no-body variant="secondary">
        <b-tabs pills card class="tabPanel" variant="secondary">

          <b-tab title="Πληροφορίες Βιβλίου">
            <b-card>
              <b-container>
                <small>
                  <div style="overflow: auto">
                    <table class="table table-sm">
                      <tbody>
                      <tr>
                        <td class="fit">
                          <li><b><i>Κωδικός Βιβλίου:</i></b></li>
                        </td>
                        <td>{{bookDto.id}}</td>
                      </tr>
                      <tr>
                        <td class="fit">
                          <li><b><i>Συγγραφείς:</i></b></li>
                        </td>
                        <td>{{bookDto.authors}}</td>
                      </tr>
                      <tr>
                        <td class="fit">
                          <li><b><i>ISBN:</i></b></li>
                        </td>
                        <td>{{bookDto.isbn}}</td>
                      </tr>
                      <tr>
                        <td class="fit">
                          <li><b><i>Εκδόσεις:</i></b></li>
                        </td>
                        <td>{{bookDto.editorialHouse}}</td>
                      </tr>
                      <tr>
                        <td class="fit">
                          <li><b><i>Αριθμός Σελίδων:</i></b></li>
                        </td>
                        <td>{{bookDto.pages}}</td>
                      </tr>
                      <tr>
                        <td class="fit">
                          <li><b><i>Διαθέτης (Εκδότης):</i></b></li>
                        </td>
                        <td>{{bookDto.publisherName}}</td>
                      </tr>
                      <tr>
                        <td class="fit">
                          <li><b><i>Ιστοσελίδα Βιβλίου:</i></b></li>
                        </td>
                        <td><a target="_blank" :href="bookDto.linkToPublisher">{{bookDto.linkToPublisher}}</a></td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </small>
              </b-container>
            </b-card>
            <br />
            <p>
              Δείτε επίσης: <a target="_blank" :href="bookDto.pathToTOC">Πίνακας Περιεχομένων</a> / <a target="_blank" :href="bookDto.pathToChapter">Ενδεικτικό Απόσπασμα</a>
            </p>

          </b-tab>

          <b-tab title="Εξώφυλλο">
            <b-card-img v-if="bookCovers.frontCover"
                        :src="bookCovers.frontCover"
                        alt="Παρακαλώ περιμένετε..."
                        bottom></b-card-img>
          </b-tab>

          <b-tab title="Οπισθόφυλλο">
            <b-card-img v-if="bookCovers.backCover"
                        :src="bookCovers.backCover"
                        alt="Παρακαλώ περιμένετε..."
                        top></b-card-img>
          </b-tab>
        </b-tabs>
      </b-card>
      <br />
      <b-btn variant="primary" block size="md" class="float-right" @click="hideModal">Κλείσιμο</b-btn>

      <div slot="modal-footer"></div>
    </b-modal>
  </b-container>
</template>

<script>
  import {GlobalEudoxusBus} from "../../js/DistributionRequestService";

  export default {
    name: "book-info-modal-component",
    props: ['bookDto', 'bookCovers'],
    data() {
      return {
        coverPathImg: '',
        backCoverPathImg: '',
        infoModal: false
      }
    },
    methods: {
      showModal() {
        this.infoModal = true;
        // this.$refs.infoModal.show();
      },
      hideModal() {
        GlobalEudoxusBus.$emit('toggleBookInfoModal', false);
      }
    },
    created() {
      GlobalEudoxusBus.$on("toggleBookInfoModal", flag => {
        // flag ? this.showModal() : this.$refs.infoModal.hide();
        flag ? this.showModal() : this.infoModal = false;
      });
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/BookDeliveryTabComponents/BookInfoModalComponent.vue